











































































import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
  
})
export default class ChooseSpeed extends Vue {
  @Prop() selectedSpeed: string;
  @Prop({default: true}) isShowTitle: boolean
  @Prop({default: false}) isSingle: boolean
  // currSpeed ='1.0';//未点击确认时的语速
  speedList =  ['0.9','1.0','1.1','1.2','1.3','1.4','1.5','1.6','1.7','1.8','1.9','2.0'];
  chooseSpeed(speed){
    this.$emit('onPickSpeed',speed);
  }
}
